import { Component, HostListener, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ScrollToFragmentService } from '@campus/public-portal';
import '@diekeure/dcr-components/dcr-animated-kai.js';
import '@diekeure/dcr-components/dcr-app-shell.js';
import '@diekeure/dcr-components/dcr-card.js';
import '@diekeure/dcr-components/dcr-divider.js';
import '@diekeure/dcr-components/dcr-image.js';
import '@diekeure/dcr-components/dcr-outline-button.js';
import '@diekeure/dcr-components/dcr-select-option.js';
import '@diekeure/dcr-components/dcr-select.js';
import '@diekeure/dcr-components/dcr-text-field.js';
import '@diekeure/dcr-components/dcr-tonal-button.js';

import { filter, switchMap, take } from 'rxjs/operators';
import { AppViewModel } from './app.viewmodel';

@Component({
  standalone: false,
  selector: 'kabas-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private appViewModel = inject(AppViewModel);

  private scrollToFragmentService = inject(ScrollToFragmentService);

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
    this.appViewModel.checkUserValidity();
  }

  ngOnInit(): void {
    this.route.queryParams
      .pipe(
        filter((queryParams) => !!queryParams?.err),
        take(1)
      )
      .subscribe(({ err }: { err?: string }) => {
        if (err === 'person_with_leerid_not_found' || err === 'unknown_questi_student') {
          this.router.navigate(['login', 'student'], { queryParamsHandling: 'preserve' });
        } else if (err === 'unknown_questi_teacher') {
          this.router.navigate(['login', 'teacher'], { queryParamsHandling: 'preserve' });
        }
      });

    this.route.fragment
      .pipe(switchMap((fragment) => this.scrollToFragmentService.scrollToFragment(fragment)))
      .subscribe();
  }
}
